import { FC } from 'react';
import { Button, Col, Row, Typography } from 'antd';
import { TbX } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

interface HeaderProps {
    onRequestClose: () => void;
}

const Header: FC<HeaderProps> = ({ onRequestClose }): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <Row
            style={{ padding: '1.25rem 1rem', borderBottom: `1px solid ${token.colorBorder}` }}
            wrap={false}
            align={'middle'}
        >
            <Col flex='none'>
                <Typography.Title level={5} style={{ marginBottom: 0 }}>
                    Edit Component
                </Typography.Title>
            </Col>
            <Col flex='auto' />
            {/* <Col flex='none'>
                <Divider type='vertical' />
            </Col> */}
            <Col flex='none'>
                <Button size='small' onClick={onRequestClose}>
                    <TbX style={{ color: token.colorTextTertiary }} />
                </Button>
            </Col>
        </Row>
    );
};

export default Header;
